import { render, staticRenderFns } from "./LinkifyText.vue?vue&type=template&id=531aad46&"
import script from "./LinkifyText.vue?vue&type=script&lang=js&"
export * from "./LinkifyText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports